import React from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CInput3 from "../../../../basecomp/components/CInput3";
import ImageUploadVM from "../viewmodel/ImageUploadVM";
import CButton from "../../../../basecomp/components/CButton";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteModal from "../../ImageComponent/DeleteModal";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CBackDrop from "../../../../basecomp/components/CBackDrop";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const AssetImagesUpload = () => {
  const navigate = useNavigate();
  const {
    assetId,
    setAssetId,
    handleFileChange,
    handleSubmit,
    previewImages,
    loadingData,
    handleConfirmDelete,
    handleCloseModal,
    handleDeleteClick,
    openModal,
    getImageName,
    fileSelected,
    loading,
    imageUrl: imageToDelete,
  } = ImageUploadVM();

  const permission = localStorage.getItem("permissionData");
  const permissionArr = permission ? permission.split(',') : [];

  const checkImageToolPermission = permissionArr.includes('feature_asset_image');
  const checkImageDeleteToolPermission = permissionArr.includes('feature_asset_image_delete');

  const handleClose = () => {
    navigate('/login'); // Navigate to login page
  };

  // If user doesn't have main image permission, show permission denied modal
  if (!checkImageToolPermission) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: "relative",
            backgroundColor: "#fff",
            borderRadius: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            width: "80%",
            maxWidth: "350px",
            textAlign: "center",
          }}
        >
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "10px",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            <CloseIcon style={{ fontSize: "35px" }} />
          </button>

          <WarningIcon
            style={{
              fontSize: "40px",
              color: "red",
              margin: "60px 30px 0",
            }}
          />
          <p
            style={{
              fontSize: "1em",
              color: "#333",
              lineHeight: "1.5em",
              fontWeight: "300",
              padding: "0 10px",
            }}
          >
            You don't have permission to access Asset Image Upload Tool. Please Contact the Conas Administrator.
          </p>

          <button
            onClick={handleClose}
            style={{
              background: "none",
              border: "none",
              width: "100%",
              fontSize: "20px",
              cursor: "pointer",
              height: "50px",
              backgroundColor: "red",
              color: "#fff",
              borderRadius: "0 0 10px 10px",
              marginTop: "20px",
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Grid item xs={10} sm={8} md={10} sx={{ margin: "5em 1em 0.5em 1em" }}>
        <Card sx={{ padding: "2em" }}>
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} sm={6} md={3}>
              <CInput3
                id="asset_id"
                cHintText="Asset ID"
                cVariant="outlined"
                cValue={assetId}
                cOnChange={(e) => setAssetId(e.target.value)}
                cFullWidth={true}
                cType="asset_id"
              />
            </Grid>
          </Grid>
          <CBackDrop cOpen={loading} />
          <DeleteModal
            open={openModal}
            onClose={handleCloseModal}
            onConfirm={handleConfirmDelete}
            cFileName={getImageName(imageToDelete)}
          />
          {previewImages.length === 5 && (
            <p style={{ textAlign: "center" }}>
              Maximum you can upload 5 Asset images
            </p>
          )}

          {!loadingData && assetId.length >= 5 && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              {!loading && (
                <>
                  {previewImages.length === 0 ? (
                    <p style={{ width: "100%", textAlign: "center" }}>
                      Asset images are not present
                    </p>
                  ) : (
                    previewImages.map((imageUrl, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          width: "250px",
                          height: "250px",
                          margin: "10px",
                          overflow: "hidden",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      >
                        {/* Only show delete icon if user has delete permission */}
                        {checkImageDeleteToolPermission && (
                          <IconButton
                            aria-label="delete"
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              zIndex: "1",
                              backgroundColor: "white",
                              borderRadius: "50%",
                            }}
                          >
                            <DeleteIcon
                              style={{ color: "green" }}
                              onClick={() => handleDeleteClick(imageUrl)}
                            />
                          </IconButton>
                        )}
                        <img
                          src={imageUrl}
                          alt={`${index + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ))
                  )}

                  {previewImages.length < 5 && (
                    <div
                      style={{
                        width: "250px",
                        height: "250px",
                        margin: "10px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: fileSelected === 0 ? "210px" : "165px",
                          border: "1px dashed #ccc",
                          borderRadius: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <IconButton
                          component="span"
                          onClick={() => {
                            const fileInput =
                              document.getElementById("image-id");
                            if (fileInput) {
                              fileInput.click();
                            }
                          }}
                        >
                          <AddAPhotoIcon />
                          <input
                            id="image-id"
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                            multiple
                          />
                        </IconButton>
                      </div>
                      {fileSelected > 0 && (
                        <p style={{ textAlign: "center", marginTop: "10px" }}>
                          {fileSelected} files selected{" "}
                        </p>
                      )}

                      <div
                        style={{
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <CButton
                          cText="Upload"
                          cTooltipText="Submit the action"
                          cDisabled={false}
                          cOnClick={handleSubmit}
                          CFullWidth={true}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </Card>
      </Grid>
    </>
  );
};

export default AssetImagesUpload;